export const HEADER_HEIGHT = '80px';
export const HEADER_HEIGHT_MOBILE = '50px';
